// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__D2SbB","gradient":"Avatar_gradient__3D-WW","small":"Avatar_small__3X69T","middle":"Avatar_middle__kCgRX","large":"Avatar_large__ou5Nn"};